// 自定义hook，完成地图组件对事件的统一处理逻辑
import * as React from 'react';
import { Events } from '../types';

const { useEffect } = React;

/**
 * 
 * @param overlay 覆盖物
 * @param events 事件对象
 */
function useBindEvents(overlay: any, events: Events | undefined) {
  useEffect(() => {
    if (!overlay || !events) {
      return;
    }

    const overlayArray = [].concat(overlay);

    Object.keys(events).forEach((eventName: string) => {
      // 这里可以对事件进行特殊的处理
      overlayArray.forEach((entity: any) => {
        entity.on(eventName, (e: any, info: any) => {
          const newEvent = {
            ...e,
            target: entity,
            trajectoryInfo: info
          };
          events[eventName](newEvent);
        });
      });
    });
  }, [overlay, events]);
}

export default useBindEvents;
